import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DefaultBgComponent} from './default-bg.component';

@NgModule({
  declarations: [DefaultBgComponent],
  imports: [CommonModule],
  exports: [DefaultBgComponent]
})
export class DefaultBgModule {}
